exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-header>.box-tools {\r\n  \r\n    top: 15px;\r\n}\r\nbody, html {\r\n    height: 100%;\r\n    margin: 0;\r\n}\r\n.username span{\r\n    margin-left:5%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/gamepage/gamepage.component.css
// module id = ../../../../../src/app/gamepage/gamepage.component.css
// module chunks = main